export default "__VITE_ASSET__DPAK_hnH__"